
import React, { useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import { Calculator } from 'lucide-react';

interface Props {
  text: string;
  children?: React.ReactNode;
}

export const AuditTooltip: React.FC<Props> = ({ text, children }) => {
  const [visible, setVisible] = useState(false);
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const triggerRef = useRef<HTMLDivElement>(null);

  const updatePos = () => {
    if (triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setPos({
        x: rect.left + rect.width / 2,
        y: rect.top
      });
    }
  };

  return (
    <div
      ref={triggerRef}
      className="inline-flex"
      onMouseEnter={() => { updatePos(); setVisible(true); }}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && createPortal(
        <div
          className="fixed z-[10000] px-3 py-2.5 bg-tooltip-bg/95 backdrop-blur-xl border border-border-dim text-tooltip-text text-xs rounded-2xl shadow-[0_20px_50px_rgba(0,0,0,0.5)] pointer-events-none -translate-x-1/2 -translate-y-full mb-3 whitespace-normal max-w-[280px] text-left leading-relaxed font-medium ring-1 ring-sal-cyber-teal/20 animate-in fade-in zoom-in-95 duration-200"
          style={{ left: pos.x, top: pos.y }}
        >
          {text.includes('Conta:') ? (
            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-1.5 border-b border-border-dim pb-1.5 mb-0.5">
                <Calculator className="w-3 h-3 text-sal-cyber-teal" />
                <span className="text-sal-cyber-teal font-black uppercase text-xs tracking-[0.15em]">Log de Auditoria</span>
              </div>
              <div className="text-tooltip-text px-0.5">{text.split('Conta:')[0]}</div>
              <div className="bg-black/10 dark:bg-black/20 p-2 rounded-xl border border-border-dim/50 font-mono text-xs text-status-ready flex flex-col gap-1">
                <span className="text-text-muted font-bold uppercase text-xs tracking-wider">Cálculo e Motivo:</span>
                <span className="leading-tight">{text.split('Conta:')[1]}</span>
              </div>
            </div>
          ) : (
            <div className="px-1 py-0.5 text-center">{text}</div>
          )}
          <div className="absolute top-full left-1/2 -translate-x-1/2 border-[6px] border-transparent border-t-[rgb(var(--tooltip-bg))]" />
        </div>,
        document.body
      )}
    </div>
  );
};
